import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
var Context = /*#__PURE__*/React.createContext({
  highlightAssets: false,
  filter: () => true
});
export default function AssetProvider(props) {
  var parent = useContext(Context);
  var children = props.children,
      _props$filter = props.filter,
      filter = _props$filter === void 0 ? parent.filter : _props$filter,
      _props$highlightAsset = props.highlightAssets,
      highlightAssets = _props$highlightAsset === void 0 ? parent.highlightAssets : _props$highlightAsset;
  var value = useMemo(() => {
    return {
      filter,
      highlightAssets
    };
  }, [filter, highlightAssets]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
}
AssetProvider.propTypes = {
  children: PropTypes.node,
  filter: PropTypes.func,
  highlightAssets: PropTypes.bool
};
AssetProvider.Context = Context;